import { motion } from 'framer-motion';
import List from '@mui/material/List';
import SidebarListItem from './SidebarListItem';
import Divider from '@mui/material/Divider';


function LeftSidebarMenu(props) {
 const {back} = props;

  return (
    <div className="flex flex-col h-full">
      <div className="px-16 py-10 flex-1 min-h-0">
        <div
          component={motion.div}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
        >
          <List className="">
          
            {back && (
			  <>
			  <SidebarListItem link={back.link}
             			   key="back"
             			   icon="heroicons-outline:arrow-left"
             			   text={back.text}/>
              <Divider style={{width:'100%', marginBottom:'10px', marginTop:'0px'}} />
			  </>
		    )}
            
             {props.children}
                     
          </List>
        </div>
      </div>
    </div>
  );
}

export default LeftSidebarMenu;
